<template>
  <el-container>
    <app-sidebar></app-sidebar>
    <el-container direction="vertical">
      <!--<app-navbar></app-navbar>-->
      <router-view></router-view>
    </el-container>
  </el-container>
</template>

<script>
import { FECTH_DASHBOARD, FECTH_AUTH } from "@/store/actions.type";

import SideBar from "@/components/Dashboard/Sidebar";
import TopNavbar from "@/components/Dashboard/TopNavbar";
import ContentFooter from "@/components/Dashboard/ContentFooter.vue";
import DashboardContent from "@/components/Dashboard/Content.vue";

export default {
  name: "Dashboard",
  created() {
    this.user();
  },
  components: {
    "app-sidebar": SideBar,
    "app-navbar": TopNavbar,
    "app-content": DashboardContent,
    "app-footer": ContentFooter,
  },
  methods: {
    user() {
      let obj = JSON.parse(localStorage.getItem("user"));
      this.$store.dispatch(FECTH_AUTH, obj);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue